import { render, staticRenderFns } from "./TextModal.vue?vue&type=template&id=a7dbabf4&scoped=true&"
import script from "./TextModal.vue?vue&type=script&lang=js&"
export * from "./TextModal.vue?vue&type=script&lang=js&"
import style0 from "./TextModal.vue?vue&type=style&index=0&id=a7dbabf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dbabf4",
  null
  
)

export default component.exports